import React, {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useState,
  } from "react";
 
  
  import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
  import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
  import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
  import { gridComponents } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
  import { Tooltip } from "@mui/material";
  import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
  import  {EyeIcon} from "../EyeIcon"
import ViewDetailPaymentModeDialog from "./ViewDetailPaymentModeDialog";  
import moment from "moment";
import { currentPaymentMoodeMapping, getConditionalPaymentInfoCall, getConditionalReferenceNumber } from "./constant";
import { getPaymentInfo } from "./utils";
import ALoader from "views/pages/manage/common/a-loader";
import { findPaymentModeKey } from "views/pages/manage/unAssigned/collectPayment/selectPaymentMode/components/constant";
import { formattedPrice } from "views/pages/manage/unAssigned/collectPayment/utils";
  
  const PaymentDetails = forwardRef(
    (
      {
        loader,
        rowList=[],
        totalPaidAmount,
        contextValue
      },
      ref
    ) => {
      const [isOpen,setOpen]=useState(false)
      const [isReceipt,setIsReceipt]=useState(false)
      const [paymentInfoLoader,setPaymentInfoLoader]= useState(false)
      const [rowData,setRowData]=useState({})
        const crossClickHandler=()=>{
          setOpen(false)
        }
      // const {setCurrentPaymentMode}= usePaymentCollectionReceiptContext()
      const {setCurrentPaymentMode,paymentModeHandler,setPaymentModeForm,studentBasicDetails}=contextValue
const actionHandler=async(rowObj)=>{
  try{
  setPaymentInfoLoader(true)
  let rowData
  if(studentBasicDetails?.receiptId&&studentBasicDetails?.receiptId.trim()){
    const isNeeded=getConditionalPaymentInfoCall(rowObj?.paymentMode)
    if(isNeeded){
    const paymentInfo = await getPaymentInfo(studentBasicDetails,rowObj)
    rowData=paymentInfo
    }
  }
  else{
    rowData=rowObj
  }
  setRowData(rowObj)
  setOpen(true)
  setIsReceipt(true)
  setCurrentPaymentMode(findPaymentModeKey(rowObj?.paymentMode)??rowObj?.paymentMode);
  setPaymentModeForm((prev)=>({...prev,
      paymentMode:rowObj?.paymentMode,
      paidAmount:formattedPrice(rowObj?.paidAmount,false),
      referenceNumber:getConditionalReferenceNumber(rowObj?.referenceNumber||rowData?.referenceNumber,rowData?.paymentMode),
      paymentModeDescription: rowData?.paymentModeDescription,
      paymentModeDate:rowObj?.paymentModeDate?moment(rowObj?.paymentModeDate):(rowData?.paymentModeDate&& moment(rowData?.paymentModeDate)),
      bank:{label:rowData?.bankName, value:rowData?.bankName},
      paymentModeAttachmentS3Key: rowData?.paymentModeAttachmentS3Key,
      gatewayName: rowData?.gatewayName,
      cardType: {label:rowData?.cardType,value:rowData?.cardType},
      firstName: rowData?.firstName,
      lastName: rowData?.LastName,
      onlineSale: {label:rowData?.onlineSale, value:rowData?.onlineSale},
      fileName: rowData?.fileName,
      createdBy: rowData?.createdBy??'-'
  }))
}catch(err){
  console.error(err)
}
finally{
  setPaymentInfoLoader(false)
}
}

      const columns = [
        new AGridColDef("paymentMode", "Payment Mode", false)
          .setMinWidth(80)
          .editable(true)
          .setFlex(0.5)
          .renderCellComponent((params) => (
            params?.value ? <Tooltip title={params?.value}>
              <div className={`ellipsis-text-container`}>{params?.value}</div>
            </Tooltip> : <div>-</div>
          )),
          new AGridColDef("referenceNumber", "Ref. Number", false)
          .setMinWidth(80)
          .editable(true)
          .setFlex(0.5)
          .renderCellComponent((params) => (
            params?.value ? <Tooltip title={params?.value}>
              <div className={`ellipsis-text-container`}>{params?.value}</div>
            </Tooltip> : <div>-</div>
          )),
          new AGridColDef("paymentModeDate", "Date", false)
          .setMinWidth(100)
          .editable(true)
          .setFlex(0.5)
          .renderCellComponent((params) => (
            params?.value ? <Tooltip title={moment(params?.value).format('DD-MM-YYYY')}>
              <div className={`ellipsis-text-container`}>{moment(params?.value).format('DD-MM-YYYY')}</div>
            </Tooltip>: <div>-</div>
          )),
          new AGridColDef("paidAmount", "Amount", false)
          .setMinWidth(60)
          .editable(true)
          .setFlex(0.5)
          .columnAlign('right')
          .renderCellComponent((params) => (
            (params?.value|| Number(params?.value)==0) ? <Tooltip title={formattedPrice( params?.value)}>
              <div className={`ellipsis-text-container regular-bolder`}>{formattedPrice( params?.value)}</div>
            </Tooltip> : <div>-</div>
          )),
          new AGridColDef("action", "Action", false)
          .setMinWidth(60)
          .editable(true)
          .setFlex(0.5)
          .columnAlign('right')
          .renderCellComponent((params) => (
           <div 
           className="cursor"
           onClick={ ()=>
           {
            actionHandler(params?.row)
             
           }
          }
           >
            {params?.row?.referenceNumber&&(params?.row?.referenceNumber).trim()&&<EyeIcon/>}</div>
          )),
      ];
  
      return (<>
      {paymentInfoLoader&&<ALoader position='fixed'/>}
        <div className="" style={{border:'1px solid #EEE', borderRadius:'8px'}}>
          <ADataGrid
            removeWrapperContainer
            rowModesModel
            rows={rowList || []}
            columns={columns}
            rowId={(row) => row?.id}
            rowHeight={50}
            rowCount={rowList.length}
            loading={false}
            components={{
              ...gridComponents,
              NoRowsOverlay: () => (
                <NoRowOverlay message={loader ? "Loading..." : null} />
              ),
            }}
            sx={{
              ...gridStyles,
            }}
            autoHeight
            hidePagination={true}
          />
        </div>
        <div className="d-flex justify-content-between align-items-center mt-24 large-text">
            <span className="label-color">
                Total Amount Paid
            </span>
            <span style={{color:'#07794C'}}>
                {formattedPrice(totalPaidAmount)}
            </span>
        </div>
        {paymentInfoLoader?<ALoader/>:
        <ViewDetailPaymentModeDialog
              isReceipt={isReceipt}
              isOpen={isOpen}
              setOpen={setOpen}
              crossClickHandler={crossClickHandler}
              contextValue={contextValue}
              rowData={rowData}
           />}
        </>
      );
    }
  );
  export default PaymentDetails;
  